var vehicleAccordion: CDN.Controls.VehicleAccordion.VehicleAccordion | null = null;
var areaAccordion: CDN.Controls.AreaAccordion.AreaAccordion | null = null;
var userToken: string = '';
var products: CDN.API.User.v1.LoginResultProduct[] = [];

var optionsPanel: HTMLElement = document.createElement('div');
var vehAccElement: HTMLElement = document.createElement('div');
var areaAccElement: HTMLElement = document.createElement('div');

CDN.requireOnce([
	{
		code: CDN.PackageCode.JQuery,
    }, {
		code: CDN.PackageCode.Control_Angular_Accordion,
	}, {
		code: CDN.PackageCode.Control_Login,
	}, {
		code: CDN.PackageCode.Control_IconMenu,
	},
	{ code: CDN.PackageCode.Component },
	{ code: CDN.PackageCode.Common },
], () => {
	let parent = document.getElementsByTagName("body")[0];
	$('#testPanel').closest('.container').addClass('d-none');

	let loginDiv: HTMLElement = document.createElement('div');
	$(loginDiv).addClass('ms-3 p-2');
	parent.appendChild(loginDiv);

	let baseElement: HTMLElement = document.createElement('div');
	$(baseElement).addClass('d-flex d-none');
	parent.appendChild(baseElement);

	let menuElement: HTMLElement = document.createElement('div');
	$(menuElement).addClass('ms-2 dark');
	$(menuElement).css('width', '80px');
	$(menuElement).css('z-index', '9999');
	baseElement.appendChild(menuElement);

	var treeViewElement: HTMLElement = document.createElement('div');
	$(treeViewElement).addClass('px-1');
	$(treeViewElement).css('width', '300px');
	baseElement.appendChild(treeViewElement);

	$(optionsPanel).addClass('p-1 bg-dark rounded mb-1');
	treeViewElement.appendChild(optionsPanel);

	$(optionsPanel).append("<div class='text-light display-selected-menu'></div>");

	$(vehAccElement).addClass('accordion-component d-none');
	$(treeViewElement).append(vehAccElement);

	$(areaAccElement).addClass('accordion-component d-none');
	$(treeViewElement).append(areaAccElement);

	let groups: CDN.Controls.IconMenuTypes.ItemGroupOptions[] = [
		{
			name: "main",
			selectionMode: CDN.Controls.IconMenuTypes.SelectionMode.SingleOrNone,
			items: [
				{ text: "Vehicles", icon: { type: "material-symbol", symbol: "local_shipping" }, afterSelectionAsync: async (selected) => { showAccordionPanel(vehAccElement, 'vehicles', selected); }, },
				{ text: "Areas", icon: { type: "material-symbol", symbol: "format_shapes" }, afterSelectionAsync: async (selected) => { showAccordionPanel(areaAccElement, 'areas', selected); }, },
			],
		}
	];

	let menu = new CDN.Controls.IconMenu(menuElement, {
		direction: CDN.Controls.IconMenuTypes.Direction.Vertical,
		groups: groups
	});

	if (sessionStorage.getItem('userToken') != null && sessionStorage.getItem('userToken') != ""
		&& sessionStorage.getItem('products') != null && sessionStorage.getItem('products') != "") {
		userToken = sessionStorage.getItem('userToken');
		products = JSON.parse(sessionStorage.getItem('products'));

		$(loginDiv).addClass('d-none');
		$(baseElement).removeClass('d-none');

		menu.selectAsync({
			group: 0,
			item: 1
		}); // 0, 0
	} else {
		let login = new CDN.Controls.Login(loginDiv, {
			onError: (err) => {
				console.error(err);
			},
			onLogin: (result) => {
				if (result.UserToken == null) {
					console.error('Invalid User Token');
					return;
				}

				userToken = result.UserToken;
				products = result.products;

				sessionStorage.setItem('userToken', userToken);
				sessionStorage.setItem('products', JSON.stringify(products));

				login.hide();
				$(loginDiv).addClass('d-none');
				$(baseElement).removeClass('d-none');

				menu.selectAsync({
					group: 0,
					item: 1
				}); // 0, 0
			}
		});
	}
});

function showAccordionPanel(element: HTMLElement, type: 'vehicles' | 'areas', selected: boolean) {
	let text: string = (!selected) ? '<i>Select an option from the menu.</i>' : type.charAt(0).toUpperCase() + type.slice(1);
	$('.display-selected-menu').html(text);
	$('.accordion-component').addClass('d-none');
	if (!selected)
		return;

	$(element).removeClass('d-none');
	if (type == 'vehicles' && vehicleAccordion === null) {
		showVehicleAccordionAsync();
	} else if (type == 'areas' && areaAccordion === null) {
		showAreaAccordionAsync();
	}
}

async function showVehicleAccordionAsync() {
	vehicleAccordion = new CDN.Controls.VehicleAccordion.VehicleAccordion(vehAccElement, userToken, products);
}

async function showAreaAccordionAsync() {
	areaAccordion = new CDN.Controls.AreaAccordion.AreaAccordion(areaAccElement, userToken, products);
}
